import CanvasVectorImageLayerRenderer 
  from 'ol/renderer/canvas/VectorImageLayer.js';

import CustomVectorLayerRenderer 
  from './VectorLayer.js';

export default class CustomVectorImageRenderer
  extends CanvasVectorImageLayerRenderer {

  constructor(layer) {
    super(layer);
  }

  prepareFrame(frameState) {

    // Force our custom vector renderer
    if (!this.vectorRenderer_ || 
        !(this.vectorRenderer_ instanceof CustomVectorLayerRenderer)) {
      this.vectorRenderer_ = 
        new CustomVectorLayerRenderer(this.getLayer());
    }

    return super.prepareFrame(frameState);
  }
}